module.exports = __webpack_public_path__ + "media/images/icons/flags/PN-4ef06ed537afeb9afa065967f96c6a1a.svg";